// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ThunderboltFilledSvg from "@fishx/icons-svg/es/asn/ThunderboltFilled";
import FishxIcon from '../components/FishxIcon';

var ThunderboltFilled = function ThunderboltFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ThunderboltFilledSvg
  }));
};

ThunderboltFilled.displayName = 'ThunderboltFilled';
export default React.forwardRef(ThunderboltFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ThunderboltFilled.js
// module id = 4251
// module chunks = 0